import * as React from 'react';
import Typography from '@mui/material/Typography';
import Section from '../components/Section';
import Button from '../components/Button';

/** フッター直前の問い合わせ導線。見出しはページごとに差し替えられる。 */
export default function CtaBand({ title = '家づくりのこと、まずはお気軽に。' }) {
  return (
    <Section bg="green" py={{ xs: 9, sm: 12 }} sx={{ textAlign: 'center' }}>
      <Typography variant="h2" component="h2" sx={{ color: 'inherit', mb: 5 }}>
        {title}
      </Typography>
      <Button tone="light" href="/contact">
        お問い合わせはこちら
      </Button>
    </Section>
  );
}
